// import React, { useEffect, useState } from 'react';
// import QRCode from 'qrcode';
// import { useTranslation } from 'react-i18next';


// type Hub3QrCodeProps = {
//   payerName: string;
//     payerAddress: string;
//     payerCity: string;
//     recipientName: string;
//     recipientAddress: string;
//     recipientCity: string;
//     recipientIBAN: string;
//     amount: string; // npr., "1000,00"
//     purpose: string;
//     model?: string;
//     reference?: string;
//     currency?: string;
// };

// const Hub3QrCode: React.FC<Hub3QrCodeProps> = ({
//   payerName,
//   payerAddress,
//   payerCity,
//   recipientName,
//   recipientAddress,
//   recipientCity,
//   recipientIBAN,
//   amount,
//   purpose,
//   model = 'HR00',
//   reference = '',
//   currency = 'EUR',
// }) => {
//   const [qrCodeUrl, setQrCodeUrl] = useState('');

//   useEffect(() => {
//      const formattedAmount = amount.replace('.', ',');
//   const hub3Text = [
//     'HRVHUB30',         // HUB type
//     currency,           // Currency (HRK or EUR)
//     formattedAmount,    // Amount in format: "1000,00"
//     payerName,          // Payer name
//     payerAddress,       // Payer address
//     payerCity,          // Payer city (optional)
//     recipientName,      // Recipient name
//     recipientAddress,   // Recipient address/city 
//     recipientCity,      // Recipient address/city (optional)
//     recipientIBAN,      // Recipient IBAN
//     model,              // Model (e.g., HR00)
//     reference,          // Reference number
//     "",                 // Code of purpose / Šifra namjene
//     purpose    
//     ].join('\n');

//     QRCode.toDataURL(hub3Text, { width: 150, errorCorrectionLevel: 'M' })
//       .then(setQrCodeUrl)
//       .catch(console.error);
//   });

// const { t } = useTranslation();
//   return (
//     <div className="flex flex-col items-center justify-center my-4">
//       <p className="text-lg font-semibold mb-2 text-center">{t('scanAndPay')}</p>
//       {qrCodeUrl ? (
//         <img src={qrCodeUrl} alt="QR kod za uplatu" />
//       ) : (
//         <p>Generiram QR kod...</p>
//       )}
//     </div>
//   );
// };

// export default Hub3QrCode;

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type Hub3BarcodeProps = {
  payerName: string;
  payerAddress: string;
  payerCity: string;
  recipientName: string;
  recipientAddress: string;
  recipientCity: string;
  recipientIBAN: string;
  amount: string; // e.g., "1000,00"
  purpose: string;
  model?: string;
  reference?: string;
  currency?: string;
};

const Hub3Barcode: React.FC<Hub3BarcodeProps> = ({
  payerName,
  payerAddress,
  payerCity,
  recipientName,
  recipientAddress,
  recipientCity,
  recipientIBAN,
  amount,
  purpose,
  model = 'HR00',
  reference = '',
  currency = 'EUR',
}) => {
  const { t } = useTranslation();

  // Generate the official HUB3 string payload and encode it for the URL API
  const barcodeUrl = useMemo(() => {
    const formattedAmount = amount.replace('.', ',');
    
    const hub3Text = [
      'HRVHUB30',         // HUB type identifier
      currency,           // Currency (e.g., EUR)
      formattedAmount,    // Amount (e.g., "1000,00")
      payerName,          // Payer name
      payerAddress,       // Payer address
      payerCity,          // Payer city
      recipientName,      // Recipient name
      recipientAddress,   // Recipient address
      recipientCity,      // Recipient city
      recipientIBAN,      // Recipient IBAN
      model,              // Model (e.g., HR00)
      reference,          // Reference number
      '',                 // Code of purpose / Šifra namjene (optional)
      purpose             // Description/Purpose of payment
    ].join('\n');

    // Use the official bwip-js public API renderer (same engine, zero local compilation baggage)
    const encodedText = encodeURIComponent(hub3Text);
    return `https://bwipjs-api.metafloor.com/?bcid=pdf417&text=${encodedText}&scale=2&height=10&includetext=false`;
  }, [payerName, payerAddress, payerCity, recipientName, recipientAddress, recipientCity, recipientIBAN, amount, purpose, model, reference, currency]);

  return (
    <div className="flex flex-col items-center justify-center my-4">
      <p className="text-lg font-semibold mb-2 text-center">{t('scanAndPay')}</p>
      <img 
        src={barcodeUrl} 
        alt="HUB3 PDF417 Barcode za uplatu" 
        className="max-w-full h-auto shadow-sm border border-gray-200 bg-white p-2"
      />
    </div>
  );
};

export default Hub3Barcode;